<template>
  <div>

    <div class="row mt-4">
      <div class="col-md-6">
        <input v-model="query.generic" class="input form-control"
               @keypress.enter="find()"
               placeholder="Pesquisar por: Chave de Acesso, Número da Nota, CNPJ ou Razão Social">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <div class="col-md-6">
        <button class="btn btn-outline px-3 mr-2"
                :class="{ 'btn-outline-active': showFilter }"
                @click="showFilter = !showFilter">
          Filtros
          <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
        </button>

        <button v-if="changeQuery" @click="find()" class="btn btn-link">
          Aplicar filtros ({{ numberOfBadges }})
        </button>
      </div>
    </div>

    <!-- Badge of keys -->
    <div v-if="$utils.isNotEmpty(query['id'])" class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearAllBadges="find()"
                      @clearBadge="find()" :filters="[filterByKeys]"/>
      </div>
    </div>

    <!-- Badge of filters -->
    <div v-else class="row">
      <div class="col-md-12">
        <BadgeFilters :filters="[filterEvent, filterType, filterCompany,
                                  filterParticipant, filterOrigin, filterValidDocument,
                                  filterBookkenping, filterTpNf, filterPeriodType,
                                  filterStartDate, filterEndDate, filterLabel
                                 ]"
                      :query="query"
                      :amountChanged="updateNumberOfBadges"
                      @clearAllBadges="$nextTick(() => find())"
                      @clearBadge="$nextTick(() => find())"/>
      </div>
    </div>

    <div v-show="showFilter">

      <div class="row mt-4">

        <div class="col-md-3">
          <label for="fd-cnpjs">Estabelecimento</label>
          <Select2 id="fd-cnpjs" v-model="query.cnpj" :options="filterCompany"/>
        </div>

        <div class="col-md-3">
          <label for="participantes">Participantes</label>
          <select v-model="query.participant" class="browser-default custom-select" id="participantes" :disabled="!hasCnpjFilter">
            <option v-for="option in filterParticipant.table" :value="option.value" :key="option.value">
              {{ option.label}}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="documento">Tipo de documento</label>
          <Select2 id="documento" v-model="query.type" :options="filterType"/>
        </div>

        <div class="col-md-3">
          <label for="fd-valid-document">Validade Jurídica</label>
          <select v-model="query.validDocument" class="browser-default custom-select" id="fd-valid-document">
            <option v-for="option in filterValidDocument.table" :value="option.value" :key="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

      </div>

      <div class="row mt-3">

        <div class="col-md-3">
          <label for="fd-event">Eventos</label>
          <Select2 id="fd-event" v-model="query.eventCodes" :options="filterEvent"/>
        </div>

        <div class="col-md-3">
          <label for="fd-origin">Origem</label>
          <Select2 id="fd-origin" v-model="query.origin" :options="filterOrigin"/>
        </div>

        <div class="col-md-3">
          <label for="fd-bookkeeping">Escriturado</label>
          <select v-model="query.bookkeeping" class="browser-default custom-select" id="fd-bookkeeping">
            <option v-for="option in filterBookkenping.table" :value="option.value" :key="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="fd-tp-nf">Entrada/Saída</label>
          <select v-model="query.tpNf" class="browser-default custom-select" id="fd-tp-nf">
            <option v-for="option in filterTpNf.table" :value="option.value" :key="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-3">
          <label for="fd-period">Tipo do Período</label>
          <select v-model="query.periodType" class="browser-default custom-select" id="fd-period">
            <option v-for="opt in filterPeriodType.table" :value="opt.value" :key="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <div class="col-md-3">
          <label for="fd-start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" class="form-control" id="fd-start-date">
        </div>

        <div class="col-md-3">
          <label for="fd-end-date">Data final</label>
          <input v-model="query.endDate" type="date" class="form-control" id="fd-end-date">
        </div>

        <div class="col-md-3">
          <label for="fd-label">Marcadores</label>
          <Select2 v-model="query.labelId" :options="filterLabel" id="fd-label"/>
        </div>
      </div>

    </div>

    <hr>
    <!-- buttons  -->
    <div class="row mt-2">
      <div class="col-md-12">
        <button v-if="$withPolicy('dfe', 'upload')" @click="showModalUpload = true" class="btn btn-primary mt-1 mr-1">Upload de notas</button>

        <Dropdown title-dropdown="Download"
                  v-if="$withPolicy('dfe', 'download_pdf', 'download_xml', 'download_report')"
                  class="btn btn-primary mt-1 mr-1"
                  :enable="enableDownload">
          <ul>
            <li v-if="$withPolicy('dfe', 'download_xml')">
              <div class="mt-3"><strong>XML</strong></div>
              <ul>
                <li class="bkps-dropdown-item ml-2" @click="download({type_format: 'xml', type_name: 'key'})">
                  Chave
                </li>
                <li class="bkps-dropdown-item ml-2" @click="download({type_format: 'xml'})">
                  Fornecedor + número da nota
                </li>
              </ul>

              <div class="mt-3"><strong>XML BROBOT</strong></div>
              <ul>
                <li class="bkps-dropdown-item ml-2" @click="download({type_format: 'xml_brobot', type_name: 'key'})">
                  Chave
                </li>
                <li class="bkps-dropdown-item ml-2" @click="download({type_format: 'xml_brobot'})">
                  Fornecedor + número da nota
                </li>
              </ul>
            </li>

            <li v-if="$withPolicy('dfe', 'download_pdf')">
              <strong>DANFE/DACTE</strong>
              <ul>
                <li class="bkps-dropdown-item ml-2" @click="download({type_format: 'pdf', type_name: 'key'})">
                  Chave
                </li>
                <li class="bkps-dropdown-item ml-2" @click="download({type_format: 'pdf'})">
                  Fornecedor + número da nota
                </li>
              </ul>
            </li>

            <li  v-if="$withPolicy('dfe', 'download_report')">
              <strong>Relatório Excel</strong>
              <ul>
                <li class="bkps-dropdown-item ml-2" @click="download({type_format: 'synthetic'})">
                  Resumido
                </li>
                <li v-if="oldAccount()" class="bkps-dropdown-item ml-2"
                    title='Modelo utilizado no sistema antigo (GED BKS)'
                    @click="download({type_format: 'synthetic_ged'})">
                  Resumido modelo antigo
                </li>
                <li class="bkps-dropdown-item ml-2" @click="download({type_format: 'detailed'})">
                  Detalhado
                </li>
                <li v-if="oldAccount()" class="bkps-dropdown-item ml-2"
                    title='Modelo utilizado no sistema antigo (GED BKS)'
                    @click="download({type_format: 'detailed_ged'})">
                  Detalhado modelo antigo
                </li>
                <li class="bkps-dropdown-item ml-2" @click="download({type_format: 'custom'})">
                  Customizado
                </li>
                <li class="bkps-dropdown-item ml-2" @click="download({type_format: 'custom_csv'})">
                  Customizado (CSV)
                </li>
              </ul>
            </li>
          </ul>

        </Dropdown>

        <Dropdown class="btn btn-primary mt-1 mr-1"
                  v-if="$withPolicy('dfe' , 'manifest')"
                  :enable="enableManifest"
                  :title-dropdown="'Manifestação'">
          <ul>
            <li v-if="enableManifestNfe">
              <div class="mt-3"><strong>NFe</strong></div>
              <ul>
                <li class="bkps-dropdown-item ml-2 mt-3 mb-2" @click="openModalManifest('210200')">
                   Confirmação da Operação
                </li>
                <li class="bkps-dropdown-item ml-2 mb-2" @click="openModalManifest('210220')">
                   Desconhecimento da Operação
                </li>
                <li class="bkps-dropdown-item ml-2 mb-3" @click="openModalManifest('210240')">
                   Operação Não Realizada
                </li>
              </ul>
            </li>
            <li v-if="enableManifestCte">
              <strong>CTe</strong>
              <ul>
                <li class="bkps-dropdown-item ml-2 mb-2" @click="openModalManifest('610110')">
                  Prestação de Serviço<br> em desacordo
                </li>
              </ul>
            </li>
          </ul>
        </Dropdown>

        <button class="btn btn-primary mt-1 mr-1"
                v-if="$withPolicy('dfe', 'consult')"
                @click="showModalConsultStatus = !!enableManifest"
                :disabled="!enableManifest">
          Consultar Status
        </button>

        <button @click="showModalSearch = true" class="btn btn-primary mt-1 mr-1">Pesquisa por chave</button>

        <Dropdown title-dropdown="Marcadores"
                  v-if="$withPolicy('dfe', 'manager_label')"
                  class="btn btn-primary mt-1 mr-1"
                  :enable="enableLabel"
                  style="width: 148px">
          <ul class="marcadores">
            <li @click="showManagerLabel = true" class="bkps-dropdown-item">
              Adicionar marcador
            </li>
            <li @click="removeLabelsFromItems"
                v-if="fiscalDocuments.some(i => i.checked && i.label)"
                class="bkps-dropdown-item">
              Remover marcador</li>
          </ul>
        </Dropdown>
				
				<Dropdown title-dropdown="Mais" class="btn btn-primary mt-1 mr-1">
					<ul class="marcadores">
						<router-link to="/dfes/alerts" tag="li" v-if="$withPolicy('dfe', 'view_alert')" class="bkps-dropdown-item">
							Alertas
						</router-link>
						
						<router-link to="/dfes/crossings" tag="li" v-if="$withPolicy('dfe', 'crossing')" class="bkps-dropdown-item">
							Cruzamento: XML x SPED
						</router-link>
            
            <router-link to="/dfes/filings" tag="li" v-if="$withPolicy('dfe', 'view_filing')" class="bkps-dropdown-item">
              Arquivados
            </router-link>

						<li>
							<div class="mt-3"><strong>Relatório customizável</strong></div>
							<ul>
								<router-link tag="li" to="/dfes/custom-reports?type=nfe" class="bkps-dropdown-item ml-2 mb-2">
									NFe
								</router-link>
								<router-link tag="li" to="/dfes/custom-reports?type=cte" class="bkps-dropdown-item ml-2 mb-2">
									CTe
								</router-link>
							</ul>
						</li>
					</ul>
				</Dropdown>

        <button v-if="showNfseNacional" class="btn btn-primary mt-1 mr-1" @click="$router.push('/dfe/documentos_ficais')">
          <repeat-icon size="1x" class="mr-1"/> NFS-e Nacional
        </button>

      </div>
    </div>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-6 mt-2">
        <strong>{{ infoTotalModels }}</strong>
        <button class="btn btn-outline ml-3 mb-1"
                v-if="fiscalDocuments.length > 0"
                @click="changeCheckAll"
                :class="{ 'btn-outline-active': checkAll}">
          {{ !checkAll ? 'Selecionar todas' : 'Desmarcar todas' }} ({{ meta.totalCount || 'Calculando' }})
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="row mt-2">
      <div class="col-md-12">

        <div class="wrap-table">
          <Table :fiscalDocuments="fiscalDocuments"
                 @changeCheckAllRow="changeCheckAllRow"
                 @changeCheckRow="changeCheckRow"
                 @showEvents="openModalEvents"
                 :checkAllRow="checkAllRow"/>
        </div>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- modals -->
    <Modal style="text-align: center;" v-model="showModalUpload" :with-footer="false">
      <h3 slot="header" class="my-2">Upload de Notas</h3>

      <div class="row">
        <div class="col-md-6 mx-auto">

          <h5 class="my-4">Você pode importar, individualmente ou em lote,<br> arquivos de obrigações acessórias, respeitando os<br> leiautes oficiais, em extensão .txt e .xml ou<br> compactados em extensão .zip.</h5>
          <UploadArchive/>

        </div>
      </div>
    </Modal>

    <Modal v-model="showModalSearch" :with-footer="true">
      <h3 slot="header" class="my-2">Pesquisa por chave</h3>

      <h4>Limite de 800 chaves (duplicadas não serão contabilizadas)</h4>
      <textarea rows="12" class="form-control mb-4" v-model="keys" placeholder="Para consultar múltiplas chaves de acesso, basta inserí-las separadas por ponto e vírgula ou uma por linha, conforme exemplo abaixo:
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX;
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,

ou

XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX">
      </textarea>

      <template v-if="outKeys">
        <h4 style="color: red;">Limite excedido. Chaves que não serão incluídas na pesquisa:</h4>
        <textarea v-model="outKeys" rows="10" class="form-control"/>
      </template>

      <div class="modal-footer">
        <button class="btn btn-primary" @click="findByKeys">Pesquisar</button>
      </div>
    </Modal>

    <Modal v-model="showModalManifest" :with-footer="false">
      <h3 slot="header" class="my-2">Manifestação</h3>

      <div class="row">
        <div class="col-md-12 text-center">

          <h5 class="mt-2">
            Tem certeza?
            <br>
            <template v-if="checkAll">
              Manifestar todas as notas baseando-se no filtro. Quantidade: {{ meta.totalCount }}
            </template>
            <template v-else>
              Manifestar {{ fiscalDocuments.filter(item => item.checked ).length }} notas
            </template>
          </h5>

          <textarea v-if="requireJustification(manifestCode)" placeholder="Justificativa" class="form-control mt-2" v-model="manifestJustification">

          </textarea>

          <div class="mt-3">
            <button class="btn btn-outline float-left" @click="showModalManifest = false">Cancelar</button>
            <button class="btn btn-success float-right " @click="sendManifestOrConsultStatus('manifest')">
              Manifestar
            </button>
          </div>

        </div>
      </div>

    </Modal>

    <Modal v-model="showModalConsultStatus" :with-footer="false" width="lg">
      <h3 slot="header" class="my-2">Consulta de status</h3>

      <div class="row">
        <div class="col-md-12 mx-auto text-center">

          <h5 class="mt-2">
            Tem certeza?
            <br>
            <template v-if="checkAll">
              Consultar status de todas as notas baseando-se no filtro. Quantidade: {{ meta.totalCount }}
            </template>
            <template v-else>
              Consultar status de {{ fiscalDocuments.filter(item => item.checked ).length }} notas
            </template>
          </h5>

          <div class="mt-3">
            <button class="btn btn-outline btn-md mr-2" @click="showModalConsultStatus = false">Cancelar</button>
            <button class="btn btn-primary btn-md" @click="sendManifestOrConsultStatus('consult_status')">
              Consultar
            </button>
          </div>

        </div>
      </div>

    </Modal>

    <ManagerLabel v-if="showManagerLabel" v-model="showManagerLabel" app="dfe"
                  @deleteLabel="deletedLabel($event)"
									className="Dfe::FiscalDocument"
                  :resources="fiscalDocuments.filter(i => i.checked)"/>

    <ModalEvents v-if="showModalEvents" v-model="showModalEvents" :fiscal-document="currentFiscalDocument"/>

  </div>
</template>

<script>
  import { ChevronDownIcon, RepeatIcon, SearchIcon } from 'vue-feather-icons'
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import Formatter from '@/models/Formatter'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Modal from '../shares/specialTag/Modal'
  import Upload from '../shares/specialTag/Upload'
  import UploadArchive from '@/components/shares/UploadArchive'
  import Dropdown from '../shares/specialTag/Dropdown'
  import ManagerLabel from '../shares/ManagerLabel'
  import RemoveLabel from '../../mixins/RemoveLabel'
  import Table from '@/components/dfe/Table'
  import CheckedModels from '@/mixins/CheckedModels'
  import ModelMapper from '@/mixins/ModelMapper'
  import handleSearchable from '@/models/handleSearchable'
  import Select2 from '@/components/shares/Select2'
  import ModalEvents from '@/components/dfe/ModalEvents'
  import GetAccount from '@/mixins/GetAccount'
  import GetUser from '@/mixins/GetUser'
  import { Filter } from '@/models/filter'
  import { CLOSED_ACCOUNT_ACTION_ERROR } from '@/utils/accountStatus'

  const components = {
    BadgeFilters,
    ChevronDownIcon,
    Dropdown,
    RepeatIcon,
    ManagerLabel,
    Modal,
    ModalEvents,
    Pagination,
    SearchIcon,
    Select2,
    Table,
    Upload,
    UploadArchive
  }

  export default {
    components: components,
    computed: {
      enableDownload() {
        return this.checkAll ||
          this.checkAllColumns ||
          (this.fiscalDocuments.length > 0 && this.fiscalDocuments.some(item => item.checked))
      },
      enableLabel() {
        return this.fiscalDocuments.some(i => i.checked) && !this.checkAll
      },
      enableManifest() {
        return this.enableManifestNfe || this.enableManifestCte
      },
      enableManifestCte() {
        return (this.checkAll && this.fiscalDocuments.length > 0) || this.fiscalDocuments.some(
          item => item.checked && ['CTe', 'CTeOS'].includes(item.fiscalDocumentType)
        )
      },
      enableManifestNfe() {
        return (this.checkAll && this.fiscalDocuments.length > 0) || this.fiscalDocuments.some(
          item => item.checked && item.fiscalDocumentType === 'NFe'
        )
      },
      fiscalDocuments() {
        return this.getModels || []
      },
      hasCnpjFilter() {
        return Array.isArray(this.query.cnpj) && this.query.cnpj.length > 0
      },
      showNfseNacional() {
        return this.getAccount.metadata.dfeSynchronizeNfseNacional
      }
    },
    created() {
      this.defaultModelSetting.updateQueryURL = true
      const keys = [
        'generic', 'participant', 'type', 'validDocument', 'origin', 'bookkeeping',
        'labelId', 'eventCodes', 'manifestCode', 'statusCode', 'id', 'tpNf', 'cnpj'
      ]
      
      keys.forEach(key => this.$set(this.query, key, ''))
      this.$set(this.query, 'periodType', 'issued_at')
      
      if (this.$utils.isEmpty(this.query.startDate)) {
        const date = new Date()
        const firstDate = new Date(date.getFullYear(), date.getMonth(), 1)
        this.$set(this.query, 'startDate', firstDate.toISOString().substring(0, 10))
      }

      this.addOrderBy('issue_date')
      this.fields.push(
        'id', 'key', 'doc_number', 'total_value', 'fiscal_document_type',
        'status_code', 'manifest_code', 'valid_document', 'origin', 'metadata',
        'issue_date', 'created_at', 'bookkeeping_date', 'label_id'
      )
      this.methods.push('xml_status', 'last_event', 'origin_formatted', 'link')
      this.includes.push('label', { participants: { methods: ['type',  'cnpj'] }})

      this.asyncTemplateSelect({
        byURL: true,
        finish: () =>  this.loadAllFilter(),
        pagination: true
      })
    },
    data() {
      return {
        currentFiscalDocument: null,
        filterBookkenping: new Filter({
          key: 'bookkeeping',
          label: 'Escriturado',
          table: [
            ['Todos', ''],
            ['Sim', 'true'],
            ['Não', 'false']
          ]
        }),
        filterByKeys: new Filter({
          key: 'id',
          label: 'Quantidade de chaves',
          valueFormatter: value =>  (value === null || value === 'ID') ? 0 : value.split(',')?.length
        }),
        filterCompany: null,
        filterEndDate: new Filter({
          key: 'endDate',
          label: 'Data final',
          type: 'date'
        }),
        filterEvent: new Filter({
          key: 'eventCodes',
          label: 'Evento',
          table: [
            ['Autorizado', '100'],
            ['Cancelado', '101'],
            ['Confirmação da Operação', '210200'],
            ['Ciência da Emissão', '210210'],
            ['Desconhecimento da Operação', '210220'],
            ['Operação não Realizada', '210240'],
            ['Prestação de Serviço em Desacordo', '610110']
          ]
        }),
        filterLabel: null,
        filterOrigin: null,
        filterParticipant: new Filter({
          key: 'participant',
          label: 'Participante',
          table: [
            ['Todos', ''],
            ['Emitente', 'issuer'],
            ['Destinatário', 'recipient'],
            ['Tomador', 'taker'],
            ['Remetente', 'sender'],
            ['Recebedor', 'receiver'],
            ['Expedidor', 'dispatcher'],
            ['Prestador', 'provider']
          ]
        }),
        filterPeriodType: new Filter({
          key: 'periodType',
          label: 'Tipo do período',
          table: [['Emissão', 'issued_at'], ['Inclusão', 'created_at'], ['Escrituração', 'bookkeeping_date']],
          valueFormatter: value =>  {
            if (value === 'created_at') return 'Inclusão'
            else if (value === 'bookkeeping_date') return 'Escrituração'
          }
        }),
        filterStartDate: new Filter({
          key: 'startDate',
          label: 'Data inicial',
          type: 'date'
        }),
        filterTpNf: new Filter({
          key: 'tpNf',
          label: 'Entrada/Saída',
          table: [['Todos', ''], ['Entrada', '0'], ['Saída', '1']]
        }),
        filterType: new Filter({
          key: 'type',
          label: 'Tipo',
          table: ['NFe', 'CTe', 'CTeOS', 'NFSe', 'GTVe']
        }),
        filterValidDocument: new Filter({
          key: 'validDocument',
          label: 'Validade jurídica',
          table: [
            ['Todos', ''],
            ['Assinatura XML VÁLIDA', 'true'],
            ['Assinatura XML INVÁLIDA', 'false']
          ]
        }),
        keys: '',
        manifestCode: null,
        manifestJustification: '',
        modelPathPrefix: 'dfe',
        nameModel: 'FiscalDocument',
        optionsLabels: [],
        outKeys: '',
        showManagerLabel: false,
        showModalConsultStatus: false,
        showModalEvents: false,
        showModalManifest: false,
        showModalSearch: false,
        showModalUpload: false,
      }
    },
    methods: {
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        return ModelMapper.methods.buildParams.call(this, pagination)
      },
      changeCheckAll() {
        this.changeCheck({ checkAll: !this.checkAll, sources: this.fiscalDocuments })
      },
      changeCheckAllRow(value) {
        this.changeCheck({ checkAllRow: value, sources: this.fiscalDocuments })
      },
      changeCheckRow(){
        this.changeCheck({ sources: this.fiscalDocuments })
      },
      deletedLabel(label) {
        if (!this.fiscalDocuments.some(f => f.label && f.label.id === label.id))
          return
        
        this.find()
        setTimeout(() => {
          this.loadFilterLabel()
        }, 500)
      },
      download(formats = {}) {
        let params = formats
        let selectedItems = this.fiscalDocuments.filter(item => item.checked)

        if (this.checkAll)
          params = { ...params, q: this.buildParams().q || {} }
        else if (selectedItems.length > 0)
          params = { ...params, q: { id: selectedItems.map(item => item.id) }}
        else
          return
  
        this.openGlobalLoad()
        this.axios.get(`${this.modelPath}/download`, { params })
          .then(response => {
            if (response.data) {
              let link = window.document.createElement('a')
              link.href = response.data
              if (response.data.endsWith('.pdf'))
                link.target = '_blank'
              link.click()
              link.remove()
            } else if (response.notice) {
              this.$notify.add(response.notice, { closingTime: 12000 })
            } else {
              console.log(response)
            }
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeGlobalLoad())
      },
      find() {
        this.asyncTemplateSelect()
      },
      findByKeys() {
        let keys = this.stringToKeys(this.keys)
        this.requestByKeys(keys)
        this.showModalSearch = false
      },
      async loadAllFilter() {
				await this.loadFilterCompany()
				await this.loadFilterOrigin()
				await this.loadFilterLabel()
			},
      async loadFilterCompany() {
        const keyLocalStorage = 'lastFilterCompanyOfDFe'
        const label = 'Estabelecimento'
        const key = 'cnpj'
				
				let options = this.$ls.get(keyLocalStorage)
				if (options)
					this.filterCompany = new Filter({ key, label, table: options })
				
        let response = await this.axios.get('companies', {
          params: {
            per_page: 1000,
            query: { type: ['parent', 'subsidiary'] }
          }
        })

				options = response.data.map(c => [
					`${c.name} - ${Formatter.cnpj(c.cnpj)}`, c.cnpj]
				)
				
				this.filterCompany = new Filter({key, label, table: options})
				this.$ls.set(keyLocalStorage, options, { minutes: 60 * 24 })
      },
      async loadFilterLabel() {
        const keyLocalStorage = 'lastFilterLabelOfDFe'
        const label = 'Marcador'
        const key = 'labelId'
        let options = this.$ls.get(keyLocalStorage)
				
        if (options)
          this.filterLabel = new Filter({ key, label, table: options })

        const params = {
          per_page: 1000,
          q: { app: 'dfe' }
        }

        const response = await this.axios.get('labels', { params: params })
        options = response.data.map(d => [d.name, `${d.id}`])

        this.filterLabel = new Filter({ key, label, table: options })
        this.$ls.set(keyLocalStorage, options, { minutes: 60 * 24 })
      },
      async loadFilterOrigin() {
        const keyLocalStorage = 'lastFilterOriginOfDFe'
        const label = 'Origem'
        const key = 'origin'

        let options = this.$ls.get(keyLocalStorage)

        if (options) {
          this.filterOrigin = new Filter({
            key, label, table: options
          })
        }

        const response = await this.axios.get('dfe/fiscal_documents/origins')
        options = Object.entries(response.data).map(([key, value]) => [value, key])

        this.filterOrigin = new Filter({ key, label, table: options })
        this.$ls.set(keyLocalStorage, options, { minutes: 60 * 24 })
      },
      oldAccount() {
        return this.getAccount.id < 375
      },
      openModalEvents(fiscalDocument) {
        this.currentFiscalDocument = fiscalDocument
        this.showModalEvents = true
      },
      openModalManifest(code) {
        this.manifestCode = code
        this.showModalManifest = true
      },
      pagination(page) {
        this.params.page = page
        this.asyncTemplateSelect({ pagination: true })
      },
      removeLabelsFromItems() {
        let fiscalDocuments = this.fiscalDocuments.filter(i => i.checked)
        this.defaultRemoveLabels('dfe', 'Dfe::FiscalDocument', fiscalDocuments)
      },
      requestByKeys(keys) {
        const queries = [{
          fields: 'id',
          name: 'byKey',
          query: { key: keys }
        }]

        this.openLoad()
        this.axios.post(`${this.modelPath}/query`, { queries: queries })
          .then(response => response.data.byKey)
          .then(fds => fds.map(fd => fd.id).slice(0, 800))
          .then(ids => this.query.id = ids.join(',') || 'ID')
          .then(() => this.find())
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
      requireJustification(code) {
        return ['210240', '610110'].includes(code)
      },
			sendManifestOrConsultStatus(service){
        if (this.accountIsClosed)
          return this.$notify.addError(CLOSED_ACCOUNT_ACTION_ERROR)

        let params = {}

        if (service === 'manifest'){
          params.code = this.manifestCode
          if (this.requireJustification(this.manifestCode))
            params.justification = this.manifestJustification
        }

        if (this.checkAll) {
          params.q = {...this.query}
        } else {
          params.q = { ids: this.fiscalDocuments.filter(i => i.checked).map(i => i.id) }
        }

        params = this.$parse.toSnakecase(this.$parse.sanitize(params))

        this.openGlobalLoad()
        this.showModalManifest = false
        this.showModalConsultStatus = false
        this.axios.post(`${this.modelPath}/${service}`, params)
          .then(response => {
            if (response.notice) {
              this.$notify.add(response.notice)
            } else if (response.data) {
              let itemUpdated = this.$parse.toCamelcase(response.data)
              let item = this.fiscalDocuments.find(i => i.id === itemUpdated.id)

              Object.keys(item).forEach(key => {
                if (itemUpdated[key])
                  item[key] = itemUpdated[key]
              })

              this.$notify.add('Operação realizada com sucesso.')
            }
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => {
            this.manifestJustification = ''
            this.closeGlobalLoad()
          })

      },
      stringToKeys(string) {
        return Array.from(
          new Set(string.replace(/\n/g, ';')
            .replace(/,/g, ';')
            .split(';')
            .map(key => key.trim())
          )
        )
      }
    },
    mixins: [GetAccount, GetUser, RemoveLabel, CheckedModels, ModelMapper],
    name: 'Index',
    watch: {
      fiscalDocuments(newValue, oldValue) {
        if (newValue !== oldValue)
          this.changeCheck({ checkAllRow: false})
      },
      keys(value) {
        const keys = this.stringToKeys(value)
        if (keys.length > 800)
          this.outKeys = keys.slice(800).join('\n')
      },
			'query.eventCodes'(eventCodes) {
				this.query.statusCode = ''
				this.query.manifestCode = ''
				
				if (!Array.isArray(eventCodes))
					return
				
				this.query.statusCode = eventCodes.filter(c => c.length === 3)
				this.query.manifestCode = eventCodes.filter(c => c.length === 6)
			}
    },
  }

</script>

<style lang="scss" scoped>

  .marcadores{
    margin-top: 12px;
    margin-right: 20px;
  }

  .marcadores li{
    margin-bottom: 10px;
    margin-left: 5px;
  }
  strong{
    color:#465059;
    font-size: 14px;
  }

  .btn-apply-filter {
    position: relative;
  }

  .diff-query {
    background-color: #fa3e3e;
    border-radius: 4px;
    color: #fff;
    width: 16px;
    height: 24px;
    position: absolute;
    right: -8px;
    top: -8px;
    font-size: 10px;
  }

  .rotate-90 {
    transform: rotate(180deg);
  }

  .fa-angle-right {
    transition: transform .2s;
    margin-left: 8px;
  }

</style>
